/* eslint-disable react/forbid-prop-types */
import React, { Component, Suspense } from 'react';
import { Col, Row, Image } from '@thd-olt-component-react/core-ui';
import { debounce } from '@thd-olt-functional/utils';
import classNames from 'classnames';
import {
  any, arrayOf, bool, func, number, oneOfType, shape, string
} from 'prop-types';
import ReactImageMagnify from 'react-image-magnify';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { MediaGalleryARRoomVoLazy } from '../MediaGalleryARRoomVoLazy/MediaGalleryARRoomVoLazy';
import './media-gallery-desktop.style.scss';
import '../../media-gallery.style.scss';
import Helper from '../../Helper';
import { mediaClick, thumbnailClick } from '../../../publisher';

const MediaGalleryOverlay = React.lazy(() => import(/* webpackChunkName: "media-gallery-overlay" */'../MediaGalleryOverlay'));

class MediaGalleryDesktop extends Component {
  constructor(props) {
    super(props);
    this.mainImageRef = React.createRef();
    this.mainImageWrapperRef = React.createRef();
    this.thumpRef = React.createRef();
    this.debouncedSetDimensions = debounce(250, this.setEnlargedImageContainerDimensions);
  }

  state = {
    mainImage: null,
    overlayOpened: false,
    selectedThumbnailIndex: 0,
    thumbnails: [],
    zoomDimension: {
      width: '100%',
      height: '100%'
    }
  };

  componentDidMount = () => {
    const { media = {} } = this.props;
    const { thumbnails = [] } = media;
    this.setState({ thumbnails }); // es-lint-disable-line react/no-did-update-set-state
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.debouncedSetDimensions);
      window.addEventListener('scroll', this.setEnlargedImageContainerDimensions);
      // eslint-disable-next-line
    }
    setTimeout(() => {
      this.setEnlargedImageContainerDimensions();
    }, 2000);
  };

  componentDidUpdate(prevProps) {
    const { media = {}, mainHover = [] } = this.props;
    const { main = [] } = media;
    if ((prevProps?.media && prevProps?.media.main[0] && prevProps.media.main[0]?.url !== main[0]?.url)) {
      this.updatePageLayout();
    }
    if (mainHover && prevProps?.mainHover !== mainHover) {
      this.updatePageHoverLayout();
    }
    if (prevProps?.media && prevProps?.mainHover && !mainHover) {
      this.updatePagePostHoverLayout();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.debouncedSetDimensions);
      window.removeEventListener('scroll', this.setEnlargedImageContainerDimensions);
    }
  }

  updatePageLayout = () => {
    const { media = {} } = this.props;
    const { main, thumbnails } = media;
    this.setState({
      mainImage: main[0],
      selectedThumbnailIndex: 0,
      thumbnails
    });
  }

  updatePagePostHoverLayout = () => {
    const { media = {} } = this.props;
    const { main, thumbnails } = media;
    const { selectedThumbnailIndex } = this.state;
    this.setState({
      mainImage: main[selectedThumbnailIndex],
      thumbnails
    });

  }

  updatePageHoverLayout = () => {
    const { media = {}, mainHover = [] } = this.props;
    const { main } = media;
    const { selectedThumbnailIndex } = this.state;
    const index = mainHover.findIndex((t) => t.type === main[selectedThumbnailIndex].type);
    const isImage = Helper.isImage({ media: mainHover[index] });
    this.setState({
      mainImage: (isImage && index > 0) ? mainHover[index] : mainHover[0]
    });
  }

  onMainImageClick = (thumbnailType) => {
    const payload = {
      eventName: 'expanded-view',
      primaryCategory: 'overlay'
    };
    thumbnailClick(payload);

    const thumbnailPayload = {
      section: 'media',
      component: 'thumbnails',
      target: thumbnailType || 'n/a',
      position: 'n/a'
    };

    mediaClick(thumbnailPayload);
    this.setState({ overlayOpened: true });
    if (typeof window !== 'undefined') {
      window.history.pushState({ page: 'MEDIAOVERLAY' }, null, '');
    }
  };

  onThumbnailEvent = (thumbnailList, images, image, thumbnail, eventType) => () => {
    const thumbnailCount = thumbnailList.length;
    const { selectedThumbnailIndex, mainImage } = this.state;
    const index = thumbnailList.findIndex((t) => t.id === thumbnail.id);
    const { totalThumbnailsToShow } = this.props;
    const isLastThumbnail = index === (totalThumbnailsToShow - 1);
    switch (eventType) {
      case 'click': {
        const currentlySelected = thumbnailList.findIndex((t, indx) => indx === selectedThumbnailIndex);
        if (index === -1 || currentlySelected === -1) return null;
        const newThumbnails = [...thumbnailList];
        this.setState({ selectedThumbnailIndex: index });

        if (isLastThumbnail && thumbnailCount > totalThumbnailsToShow) {
          this.onMainImageClick(thumbnail.type);
        } else {
          const payload = {
            section: 'media',
            component: 'thumbnails',
            target: thumbnail.type,
            position: index + 1
          };

          mediaClick(payload);
          const mainAsset = mainImage || {};
          // Clicking on a thumbnail should open the overlay UNLESS the thumbnail is a plain image
          this.setState({
            mainImage: images[index],
            thumbnails: newThumbnails,
            overlayOpened: !Helper.isImage({ media: mainAsset })
          });
        }
        break;
      }
      case 'mouseenter': {
        this.setState({ mainImage: images[index], selectedThumbnailIndex: index });
        break;
      }
      default: break;
    }
    this.setEnlargedImageContainerDimensions();
    return null;
  };

  setEnlargedImageContainerDimensions = () => {
    const {
      marqueeRef,
      marqueeRowRef,
      media
    } = this.props;
    const {
      mainImage,
      selectedThumbnailIndex
    } = this.state;
    const zoomDimension = {
      width: '100%',
      height: '100%'
    };
    const { highResolution = [], main = [] } = media;
    const mainAsset = mainImage || (main && main[selectedThumbnailIndex]) || {};
    const { id } = mainAsset;
    const highResImage = highResolution.find((image) => image.id === id);
    const maxWidth = highResImage ? 2000 : 1000;
    const maxHeightForImage = highResImage ? 2000 : 1000;
    const mainImageDiv = this.mainImageRef.current || null;
    if (mainImageDiv && marqueeRef && marqueeRowRef && marqueeRef.current && marqueeRowRef.current) {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const mainImageBoundBox = mainImageDiv.getBoundingClientRect();
      if (mainImageBoundBox.bottom >= 0) {
        const distanceFromTopViewPort = mainImageBoundBox.top > 0 ? mainImageBoundBox.top : 0;
        const mainImageWrapperStyle = window.getComputedStyle(this.mainImageWrapperRef.current);
        const mainImageMarginLeft = parseInt(mainImageWrapperStyle.getPropertyValue('margin-left'), 10);
        const colMarginLeft = 10; // Left margin of media-gallery col component
        const verticalZoomMargin = 10; // margin required on left and right of zoom area
        const horizontalZoomMargin = 20;
        const marqueeRowWidth = marqueeRowRef.current.clientWidth;
        const marqueeRowHeight = marqueeRowRef.current.clientHeight;
        const marqueeRowStyle = window.getComputedStyle(marqueeRowRef.current);
        const marqueeRowPaddingLeft = parseFloat(marqueeRowStyle.getPropertyValue('padding-left'));
        const containerMargin = (windowWidth - marqueeRowWidth) / 2;
        const galleryWidth = marqueeRef.current.clientWidth;
        // gap after main image
        const galleryGapInRight = galleryWidth - (
          this.thumpRef.current.clientWidth + mainImageDiv.clientWidth
          + mainImageMarginLeft + marqueeRowPaddingLeft + colMarginLeft
        );
        const galleryTopGap = (this.mainImageWrapperRef.current.clientHeight - mainImageDiv.clientHeight) / 2;
        const zoomWidth = ((marqueeRowWidth - galleryWidth) + containerMargin + galleryGapInRight) - (2 * horizontalZoomMargin);
        const maxHeightForWindow = windowHeight - distanceFromTopViewPort - verticalZoomMargin;
        const maxHeight = Math.min(maxHeightForImage, maxHeightForWindow);
        const zoomHeight = marqueeRowHeight - (galleryTopGap + verticalZoomMargin);
        if (zoomDimension.width !== zoomWidth || zoomDimension.height !== zoomHeight) {
          zoomDimension.width = Math.min(zoomWidth, maxWidth);
          zoomDimension.height = Math.min(zoomHeight, maxHeight);
        }
      }
    }
    this.setState({ zoomDimension });
  };

  hideOverlay = (e) => {
    this.setState({ overlayOpened: false });
  };

  renderMainImage = (media = {}) => {
    const { mainImage, selectedThumbnailIndex, zoomDimension } = this.state;
    const { showFavorites } = this.props;
    const { highResolution = [], main = [], zoom = [] } = media;
    const mainAsset = mainImage || main[selectedThumbnailIndex] || {};
    const {
      id, collectionId, mediaStill, url, videoStill, type, collection
    } = mainAsset;
    const highResImage = highResolution.find((image) => image.id === id);
    const zoomedAsset = highResImage || zoom.find((z) => z.id === id);
    const largeImage = zoomedAsset ? zoomedAsset.url : mainAsset.url;

    const magnifyLargeImage = {
      src: largeImage,
      width: highResImage ? 2000 : 1000,
      height: highResImage ? 2000 : 1000
    };
    const imageMagnifyProps = {
      smallImage: {
        alt: '',
        isFluidWidth: true,
        src: url
      },
      largeImage: magnifyLargeImage,
      lensStyle: {
        backgroundImage: '',
      },
      enlargedImageContainerClassName: 'mediagallery__zoom-container',
      shouldUsePositiveSpaceLens: true,
      enlargedImageContainerDimensions: zoomDimension
    };

    return (
      mainAsset
        ? (
          <>
            <div ref={this.mainImageRef} className="mediagallery__mainimageblock mediagallery__mainimageblock--size">
              {showFavorites && (
                <div className="media-gallery-favorite">
                  <Favorite
                    collectionId={collectionId}
                    collectionImage={url}
                    position="topRight"
                    showCircle
                  />
                </div>
              )}
              <a role="presentation" className="mediagallery__anchor" onClick={() => this.onMainImageClick(type)}>
                {Helper.isVideo({ media: mainAsset })
              && (
                <>
                  <Image
                    className="mediagallery__video"
                    src={videoStill}
                    alt={id || 'video still'}
                    lazy
                    height="600"
                    width="600"
                  />
                  <span className="background-circle background-circle--main" />
                  <span className="play-icon play-icon--main" />
                </>
              )}
                {Helper.isAR({ media: mainAsset })
                && (
                  <>
                    <Image
                      stretchy
                      src={mediaStill}
                      alt={id || 'AR still'}
                      lazy
                      height="600"
                      width="600"
                    />
                    <span className="background-circle background-circle--main" />
                    <span className="ar-icon ar-icon--main" />
                  </>
                )}
                {Helper.isImage360({ media: mainAsset })
                && (
                  <>
                    <Image
                      stretchy
                      src={mediaStill}
                      alt={id || '360 image'}
                      lazy
                      height="600"
                      width="600"
                    />
                    <span className="background-circle background-circle--main" />
                    <span className="threesixty-icon threesixty-icon--main" />
                  </>
                )}
                {Helper.isImage({ media: mainAsset })
                && (
                  <>
                    <ReactImageMagnify {...imageMagnifyProps} />
                    <span className="mediagallery__mainimageicons--expand" />

                    {collection
                    && (
                      <div className="shopThisRoomContainer">
                        <a className="shopThisRoomLink" target="_blank" rel="noreferrer" href={collection} onClick={(e) => e && e.stopPropagation()}> Shop This Room </a>
                      </div>
                    )}
                    {!Helper.isTouchEnabled() && <span className="mediagallery__cta">Hover Image to Zoom</span>}
                  </>
                )}
              </a>
            </div>
          </>
        )
        : null
    );
  };

  renderThumbnails = (thumbnailList = [], mainImageList = []) => {
    const { selectedThumbnailIndex } = this.state;
    const { totalThumbnailsToShow } = this.props;
    const availableThumbnails = (thumbnailList)
      .map((thumbnail, index) => ({
        ...thumbnail,
        isSelected: selectedThumbnailIndex === index
      }));
    const thumbnailCount = thumbnailList.length;

    return (
      thumbnailCount
        ? (
          <>
            {
              availableThumbnails
                .slice(0, totalThumbnailsToShow)
                .map((thumbnail, thumbnailIndex) => {
                  const isAR = Helper.isAR({ media: thumbnail });
                  const isVideo = Helper.isVideo({ media: thumbnail });
                  const isThreesixty = Helper.isImage360({ media: thumbnail });
                  const { id, url, videoStill, mediaStill = '' } = thumbnail;

                  let thumbnailUrl = url;
                  if (isAR) {
                    thumbnailUrl = mediaStill;
                  } else if (isVideo) {
                    thumbnailUrl = videoStill;
                  } else if (isThreesixty) {
                    thumbnailUrl = `${url}?thumb&profile=400`;
                  }

                  const isLastThumbnail = thumbnailIndex === (totalThumbnailsToShow - 1);
                  const mediaStyles = classNames(
                    'mediagallery__thumbnail',
                    { 'mediagallery__thumbnail--selected': thumbnail.isSelected }
                  );

                  const mediaProps = {
                    className: 'mediagallery__imgblock',
                    onClick: this.onThumbnailEvent(availableThumbnails, mainImageList, thumbnail, thumbnail, 'click'),
                    onMouseEnter: this.onThumbnailEvent(availableThumbnails, mainImageList, thumbnail, thumbnail, 'mouseenter'),
                    onMouseLeave: this.onThumbnailEvent(availableThumbnails, mainImageList, thumbnail, thumbnail, 'mouseout')
                  };

                  const isImagePath = (/^(?=.*\/productImages\/).*$/.test(thumbnailUrl));
                  const reducedThumbnailUrl = (thumbnailUrl || '').replace('_145.', '_100.');
                  const finalReducedThumbnailUrl = (reducedThumbnailUrl || '').replace('catalog/productImages/145', 'catalog/productImages/100');
                  const finalThumbnailUrl = isVideo ? (thumbnailUrl || '').replace('/1280x720/match', '/88x50/match') : thumbnailUrl;
                  const finalHeight = isVideo ? '50' : '88';
                  return (
                    <div className={mediaStyles} key={thumbnailIndex}>
                      <button {...mediaProps} type="button">
                        <Image
                          src={isImagePath ? finalReducedThumbnailUrl : finalThumbnailUrl}
                          alt={id || ''}
                          lazy
                          height={finalHeight}
                          width="88"
                        />
                        {isAR && (
                          <>
                            <span className="background-circle background-circle--thumbnail" />
                            <span className="ar-icon ar-icon--thumbnail" />
                          </>
                        )}
                        {isVideo
                      && (
                        <>
                          <span className="background-circle background-circle--thumbnail" />
                          <span className="play-icon play-icon--thumbnail" />
                        </>
                      )}
                        {isThreesixty
                        && (
                          <>
                            <span className="background-circle background-circle--thumbnail" />
                            <span className="threesixty-icon threesixty-icon--thumbnail" />
                          </>
                        )}
                        {(isLastThumbnail && thumbnailCount > totalThumbnailsToShow)
                      && (
                        <>
                          <span className="mediagallery__thumbnail--fade" />
                          <span className="mediagallery__thumbnailicons--count">
                            +{thumbnailCount - (totalThumbnailsToShow - 1)}
                          </span>
                        </>
                      )}
                      </button>
                    </div>
                  );
                })
            }
          </>
        )
        : null
    );
  };

  render() {
    const {
      collection, marqueeRef, media, hideProductImagesLabel, product, configuredProductLabel
    } = this.props;
    const { itemId, identifiers } = product || {};
    const { main } = media;
    const { mainImage, overlayOpened, thumbnails } = this.state;
    const overlayClassName = classNames({
      'mediagalleryoverlay--open': overlayOpened,
      'mediagalleryoverlay--closed': !overlayOpened
    });
    if (marqueeRef && marqueeRef.current) {
      marqueeRef.current.classList.remove('mediagalleryoverlay--open');
      marqueeRef.current.classList.remove('mediagalleryoverlay--closed');
      marqueeRef.current.classList.add(overlayClassName);
    }
    const isServer = typeof window === 'undefined';

    return (
      <Row id="media-gallery">
        <Col>
          <div className="mediagallery">
            <div ref={this.thumpRef} className="mediagallery__thumbnails">
              {this.renderThumbnails(thumbnails, main)}
            </div>
            <div ref={this.mainImageWrapperRef} className="mediagallery__mainimage">
              {this.renderMainImage(media)}
            </div>
            {
              overlayOpened && (
                <Suspense fallback={<div />}>
                  <MediaGalleryOverlay
                    handleClose={this.hideOverlay}
                    overlayOpened={overlayOpened}
                    collection={collection}
                    media={media}
                    product={product}
                    mainAsset={mainImage || main[0]}
                    thumbnails={thumbnails}
                    hideProductImagesLabel={hideProductImagesLabel}
                    configuredProductLabel={configuredProductLabel}
                  />
                </Suspense>
              )
            }
          </div>
          {!isServer && identifiers?.roomVOEnabled && <MediaGalleryARRoomVoLazy itemId={itemId} />}
        </Col>
      </Row>
    );
  }
}

MediaGalleryDesktop.propTypes = {
  collection: shape({}),
  mainHover: arrayOf(shape({
    id: string,
    location: string,
    type: string
  })),
  marqueeRef: oneOfType([
    func,
    shape({ current: any })
  ]),
  marqueeRowRef: oneOfType([
    func,
    shape({ current: any })
  ]),
  media: shape({
    main: arrayOf(shape({
      id: string,
      location: string,
      type: string
    })),
    thumbnails: arrayOf(shape({
      id: string,
      location: string,
      type: string
    })),
    zoom: arrayOf(shape({
      id: string,
      location: string,
      type: string
    })),
    highResolution: arrayOf(shape({
      id: string,
      location: string,
      type: string
    }))
  }),
  product: shape({}),
  showFavorites: bool,
  totalThumbnailsToShow: number,
  hideProductImagesLabel: bool,
  configuredProductLabel: string
};

MediaGalleryDesktop.defaultProps = {
  collection: null,
  mainHover: [{
    id: '',
    location: '',
    type: ''
  }],
  marqueeRef: null,
  marqueeRowRef: null,
  media: {
    main: [{
      id: '',
      location: '',
      type: ''
    }],
    thumbnails: [{
      id: '',
      location: '',
      type: ''
    }],
    zoom: [{
      id: '',
      location: '',
      type: ''
    }],
    highResolution: []
  },
  product: {},
  showFavorites: false,
  totalThumbnailsToShow: 0,
  hideProductImagesLabel: false,
  configuredProductLabel: null
};

export { MediaGalleryDesktop };
